module.exports = __webpack_public_path__ + "static/Picture-2-9597cf5119d7ecd3efdb0c8affb8f63c.jpg";